import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  marketsList: [],
  status: 'idle',
  error: null,
};

const marketsListSlice = createSlice({
  name: 'marketsList',
  initialState,
  reducers: {
    setMarketsList: (state, action) => {
      state.marketsList = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setMarketsList, setError, setLoading } =
  marketsListSlice.actions;
export default marketsListSlice.reducer;
